import { createFileRoute } from "@tanstack/react-router";
import { GeneralSection } from "@/features/food-sessions/general-section";
import { FoodSessionId } from "@brewbase/db/types";

export const Route = createFileRoute("/food-app/sessions/$session_id/general")({
  component: GeneralPage,
});

function GeneralPage() {
  const { session_id } = Route.useParams();

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="p-6">
        <GeneralSection session_id={session_id as FoodSessionId} />
      </div>
    </div>
  );
}
